import { render, staticRenderFns } from "./InfraSwitch.vue?vue&type=template&id=14668c25&"
import script from "./InfraSwitch.vue?vue&type=script&lang=js&"
export * from "./InfraSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports